import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { AccountInfo } from '../components/account-info/account-info.component';
import { CustomHttpParamsEncoder } from './settings/CustomHttpParamsEncoder';

@Injectable({
  providedIn: 'root'
})
export class AccountInfoService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public update(accountInfo): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    const params = new HttpParams({ encoder: new CustomHttpParamsEncoder() })
      .append('geocode_address', 'true')
      .append('project_id', project!.projectID!.id)
      .append('attributes', 'acceptedPrivacyPolicy,acceptedTermsOfUse,firstName,address,gender,language,userType,sendToInboxFromPhone,birthYear');
    const token = JSON.parse(localStorage.getItem('token_info'));
    const headers: HttpHeaders = new HttpHeaders()
      .append('Authorization', `${token['token_type']} ${token['access_token']}`);
    return this.http.post(this.config.getEndpoint('member/user_update'), this.toDbo(accountInfo), { params, headers });
  }

  private toDbo(uiModel: AccountInfo) {
    const resToDbo = {
      attributes: {
        acceptedTermsOfUse: [uiModel.acceptedTermsOfUse],
        acceptedPrivacyPolicy: [uiModel.acceptedPrivacyPolicy],
        sendToInboxFromPhone: [false],
        firstName: [uiModel.firstName],
        address: [
          {
            street: uiModel.address.street,
            houseNumber: uiModel.address.houseNumber,
            boxNumber: "",
            postalCode: uiModel.address.postalCode,
            municipality: uiModel.address.municipality,
            country: uiModel.address.country
          }
        ],
        gender: [uiModel.gender],
        language: [uiModel.language],
        userType: [uiModel.iam],
        birthYear: uiModel.birthYear && [uiModel.birthYear] || null
      },
      userId: {
        '@class': '.UserID',
        id: uiModel.userId
      }
    }
    return resToDbo;
  }
}
